import type {
  OnFormSubmitProps,
  useObservationCommentFormProps,
} from "./observation-comment-form.type";

import { useCreate } from "@/hooks/queries";
import { useCommentForm } from "@/modules/comment/comment-form";

export const useObservationCommentForm = ({
  observation,
  onSuccess,
  onError,
}: useObservationCommentFormProps) => {
  const { form, onFormSuccess, onFormError } = useCommentForm();

  const { mutate, isPending: isLoading } = useCreate("observations.comments", {
    rootId: observation?.id,
  });

  const onFormSubmit = (values: OnFormSubmitProps): void => {
    const data = { content: values.comment };

    mutate(data, {
      onSuccess: () => {
        onFormSuccess();
        onSuccess?.();
      },
      onError: () => {
        onFormError();
        onError?.();
      },
    });
  };

  return {
    form,
    onFormSubmit,
    isLoading,
  };
};
